import { IAction } from '@Root/types'
import { IUploadedAvatar } from '@Utils/AvatarUploader'

import {
  ISubscriptionData
} from '@SiteModules/Subscription/types'

import {
  IAccountData
} from '@SiteModules/Account/types'

export const UserActionTypes = {
  LOGOUT: '@@user/LOGOUT',
  LOGOUT_FAILURE: '@@user/LOGOUT_FAILURE',
  LOGOUT_SUCCESS: '@@user/LOGOUT_SUCCESS',

  GET_INFO: '@@user/GET_INFO',
  GET_INFO_FAILURE: '@@user/GET_INFO_FAILURE',
  GET_INFO_SUCCESS: '@@user/GET_INFO_SUCCESS',

  UPDATE_PROFILE: '@@user/UPDATE_PROFILE',
  UPDATE_PROFILE_SUCCESS: '@@user/UPDATE_PROFILE_SUCCESS',
  UPDATE_PROFILE_FAILURE: '@@user/UPDATE_PROFILE_FAILURE',

  CONNECT_EXTERNAL_CHANNEL: '@@user/CONNECT_EXTERNAL_CHANNEL',

  CREATE_CUSTOMER_PORTAL_SESSION: '@@user/CREATE_CUSTOMER_PORTAL_SESSION',
  CREATE_CUSTOMER_PORTAL_SESSION_FAILURE: '@@user/CREATE_CUSTOMER_PORTAL_SESSION_FAILURE',

  OPEN_SSO_ADMIN_PORTAL: '@@user/OPEN_SSO_ADMIN_PORTAL',

  SET_LAST_VIEWED_ALERT: '@@user/SET_LAST_VIEWED_ALERT',

  SET_LAST_USED_ACCOUNT_SUCCESS: '@@user/SET_LAST_USED_ACCOUNT_SUCCESS',
  SET_LAST_USED_WORKSPACE_SUCCESS: '@@user/SET_LAST_USED_WORKSPACE_SUCCESS',

  RESET_SHOULD_SEE_NEWSLETTER_POPUP_SUCCESS: '@@user/RESET_SHOULD_SEE_NEWSLETTER_POPUP_SUCCESS',

  SET_USE_LIGHT_THEME: '@@user/SET_USE_LIGHT_THEME',
  RESET_USE_LIGHT_THEME: '@@user/RESET_USE_LIGHT_THEME',

  SET_UPLOADING_AVATAR: '@@user/SET_UPLOADING_AVATAR',
  CHANGE_AVATAR: '@@user/CHANGE_AVATAR',
  CHANGE_AVATAR_SUCCESS: '@@user/CHANGE_AVATAR_SUCCESS',
  CHANGE_AVATAR_FAILURE: '@@user/CHANGE_AVATAR_FAILURE',
}

export interface IConnectExternalChannel {
  readonly service: string
}

export interface IOpenSsoAdminPortal {
  readonly ssoOrganizationId: number
}

export interface ISetLastViewedAlert {
  readonly alertId: number
}

export interface IUserState {
  readonly user: IUser
  readonly hasLoadedSuccessfully: boolean
  readonly useLightTheme: boolean
  readonly saving: boolean
  readonly hasUpdatedProfileSuccessfully: boolean
  readonly errorMessageCurrentPasswordForNewEmail: null | string
  readonly errorMessageCurrentPasswordForNewPassword: null | string
  readonly uploadingAvatar: boolean
}

export interface IUser {
  readonly id: number
  readonly attributes: IUserAttributes
}

export interface IUserData {
  readonly id: string
  readonly type: 'user'
  readonly attributes: IUserAttributes
}

export interface IUserAttributes {
  readonly name?: string
  readonly email: string
  readonly lastName?: string
  readonly role: string
  readonly onboardingState: string
  readonly confirmedEmail: boolean
  readonly relevantAlert: IAlert | null
  readonly numberOfProjectsSuccessfullyCreated: number
  readonly shouldSeeNewsletterPopup: boolean
  readonly hasSelectedRole: boolean
  readonly firstProjectType: string | undefined
  readonly lastUsedAccountId?: number
  readonly lastUsedWorkspaceId?: number
  readonly avatarUrl?: string
}

export interface IAlert {
  readonly id: number
  readonly message: string
  readonly linkLabel?: string
  readonly linkUrl?: string
}

export interface IGetUserInfoSuccessResponseBody {
  readonly user: {
    readonly data: IUserData,
  }
  readonly accounts: {
    readonly data: IAccountData[]
    readonly included: ISubscriptionData[]
  }
}

export interface ICreateCustomerPortalSessionPayload {
  readonly accountId: number
}

export interface ILogoutPayload {
  readonly forwardingUrl: string
}

export interface ISetLastUsedAccountSuccessPayload {
  readonly accountId: number
}

export interface ISetLastUsedWorkspaceSuccessPayload {
  readonly workspaceId: number
}

export interface IUpdateProfilePayload {
  readonly userId: number
  readonly password?: string
  readonly name?: string
  readonly lastName?: string
  readonly email?: string
  readonly currentPassword?: string
  readonly role?: string
  readonly organizationSize?: string
  readonly videoQuantityPerMonth?: string
  readonly shouldFinishSurvey?: boolean
}

export type IUpdateProfileSuccessPayload = IUpdateProfilePayload

export interface IUpdateProfileFailurePayload {
  readonly errorMessageCurrentPasswordForNewEmail?: string
  readonly errorMessageCurrentPasswordForNewPassword?: string
}

export interface IChangeAvatarPayload extends IUploadedAvatar {
  readonly userId: number
}

export type IChangeAvatarSuccessPayload = IChangeAvatarPayload

export type TUserActionTypes =
  IAction<IGetUserInfoSuccessResponseBody> |
  IAction<ISetLastUsedAccountSuccessPayload> |
  IAction<ISetLastUsedWorkspaceSuccessPayload> |
  IAction<IUpdateProfileSuccessPayload> |
  IAction<IUpdateProfileFailurePayload> |
  IAction<IChangeAvatarSuccessPayload>
